// extracted by mini-css-extract-plugin
export default {"myPhoto":"MyPhoto_myPhoto__MRAy7"};